<template>
  <main class="shoppinglist-stage detail-stage">
    <div class="pic-stage">
      <div class="container">
        <div
          class="bg"
          :style="
            pics.headerPicSharepage
              ? `background-image: url(${pics.headerPicSharepage})`
              : 'background-image: url(/assets/images/bg-shoppinglist.jpg)'
          "
        ></div>
        <div class="bgcontent">
          <router-link :to="{ path: '/' }" class="main-logo shoppinglist-left" title="Zur Startseite"></router-link>
        </div>
      </div>
    </div>
    <div class="content" ref="content">
      <div class="details">
        
        <h1>{{ $l("listpageMainHeadline") }}</h1>
        <p class="sub">{{ $l("listpageMainSubline") }}</p>
        
        <!--
        <button v-on:click.prevent="jumpToList" class="button-primary">
          Eigene Merkliste erstellen
        </button>
        -->
        
        <h2>
          <img src="/assets/images/shoppinglist-icon-brombeere.png" alt="" aria-hidden="true" />{{
            $l("listpageHeadline")
          }}
        </h2>

        <img src="/assets/images/loading.gif" class="loading" v-if="loading" alt="Daten werden geladen..." />

        <MarketInfosBox
          :customMarket="shoppinglistMarket"
          v-if="shoppinglistMarket && !loading"
        />

        <div class="no-market-hint" v-if="!loading">
          Verkauf nur solange der Vorrat reicht.
        </div>

        <ShoppinglistItems
          :items="fullItems"
          :view="true"
          :sharelist="key"
          v-if="!loading"
        />
      </div>

      <ShoppinglistShare class="border-bottom" :sharepage="true" />

      <div class="mobile-home-section">
        <div class="mobilecontent">
          <h2>{{ $l("listpageMainHeadline") }}</h2>
          <p>{{ $l("listpageMainSubline") }}</p>
          <router-link :to="{ path: '/' }" class="button-primary"
            >Eigene Merkliste erstellen</router-link
          >
        </div>
      </div>

      <HomeOutro class="mobile" />

      <FooterComponent :border="false" />
    </div>
  </main>
</template>

<script>
const randomIndex = max => Math.floor(Math.random() * max + 1);

import { mapState, mapGetters } from "vuex";
import moment from "moment";
import MarketInfosBox from "@/components/MarketInfosBox.vue";
import ShoppinglistItems from "@/components/ShoppinglistItems";
import ShoppinglistShare from "@/components/ShoppinglistShare";
import HomeOutro from "@/components/HomeOutro";
import FooterComponent from "@/components/Footer";
export default {
  name: "shoppinglist",
  components: {
    MarketInfosBox,
    ShoppinglistItems,
    ShoppinglistShare,
    HomeOutro,
    FooterComponent
  },
  data() {
    return {
      loading: true,
      key: false,
      shoppinglistItems: [],
      shoppinglistMarket: false,
      shoppinglistMarketProducts: []
    };
  },
  mounted: async function() {
    this.$store.commit("SET_SHOW_SCROLLBAR", false);
    this.key = this.$route.params.key;
    const response = await this.$store.dispatch(
      "getShoppinglistPublic",
      this.key || false
    );
    this.shoppinglistItems = response.items;
    this.shoppinglistMarket = response.market;
    if (this.shoppinglistMarket && this.shoppinglistMarket.nr) {
      this.shoppinglistMarketProducts = await this.$store.dispatch(
        "getMarketProducts",
        this.shoppinglistMarket.nr
      );
    }
    this.loading = false;

    this.$trackPageView({ name: ":merklistenseite", hierarchy: [] });
  },
  destroyed() {
    this.$store.commit("SET_SHOW_SCROLLBAR", true);
  },
  methods: {
    jumpToList() {
      this.$router.push({ name: "home" });
      window.setTimeout(() => {
        this.$store.commit("SET_JUMPTOLIST", true);
      }, 200);
    }
  },
  watch: {},
  computed: {
    ...mapState(["allProducts", "pics"]),
    currentYear() {
      return moment().format("Y");
    },
    fullItems() {
      const items = [];
      this.shoppinglistItems.forEach(item => {
        const product = this.allProducts.find(p => p.nr === item.nr);
        if(product) {
          if (this.shoppinglistMarket) {
            product.available = this.shoppinglistMarketProducts.find(
              el => el.nr === item.nr
            )
              ? true
              : false;
          } else {
            product.available = true;
          }

          product.count = item.count;
          product.added = item.added;
          items.push(product);
        }
      });
      items.sort((a, b) =>
        a.added > b.added ? -1 : a.added < b.added ? 1 : 0
      );
      return items;
    }
  }
};
</script>

<style lang="scss">
@import "./Shoppinglist";
</style>
